export enum ACTIONS {
    SET_AI_AVATAR_VOICE_PRESETS = 'SET_AI_AVATAR_VOICE_PRESETS',
    SET_AI_AVATARS = 'SET_AI_AVATARS',
    SET_AI_VOICES = 'SET_AI_VOICES',
    SET_AI_VOICEOVER_BATCH_COMPLETE = 'SET_AI_VOICEOVER_BATCH_COMPLETE',
}
